module.exports = {
      id: "left-arrow-usage",
      viewBox: "0 0 26 26",
      url: __webpack_public_path__ + "svg-sprite-9bf32fda02e4f885c0073d291388af8d.svg#left-arrow",
      toString: function () {
        return this.url;
      }
    }